import React from 'react';


class Zubereitung extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      zubereitung : this.props.zubereitungcontainer.zubereitung,
      schritt : this.props.zubereitungcontainer.schritt,
      deleteVisible : false,
      deleteElement: false,
      divStyle : null
    };

    this.handleChange = this.handleChange.bind(this);
  
    this.proofDeletion = this.proofDeletion.bind(this);
  }
  
  handleChange(element, event) {
      var ReactDOM = require('react-dom');
      var node = ReactDOM.findDOMNode(this.contentRef);
      var valuehtml = node.innerHTML;
        switch(element) {
        case 'zubereitung':
          //this.setState({ zubereitung:valuehtml });
        break;
        case 'schritt':
          //this.setState({ schritt:valuehtml });
        break;
        
      default:
      break;
      }
      if(valuehtml.length > 0) {
        this.setState({ deleteVisible: true });
      }
      
      let dataContainer = {};
      
      dataContainer.deleteElement = false;
      dataContainer.wert = valuehtml;
      dataContainer.element = element;
      dataContainer.keyzc = this.props.keyzc;
     this.props.onZubereitungElementChange(dataContainer);
     
  }
  proofDeletion(event) {
    event.preventDefault();
    let dataContainer = {};

    dataContainer.deleteElement = true;
    dataContainer.keyzc = this.props.keyzc;
    this.props.onZubereitungElementChange(dataContainer);
  }
  handleSubmit(event) {
       //event.preventDefault();
  }
    render() {
      let deleteVisible = "delete-button " +  ((this.state.deleteVisible === true) ? 'visible' : ' hidden');
      
      return (
        <li className="Component Zubereitung">
        
            <p>Schritt <span>{this.state.schritt}</span></p>
            <div ref={(contentRef) => { this.contentRef = contentRef; }} className="contentEditable"  contentEditable="true" onInput={this.handleChange.bind(this, 'zubereitung')}>
              {this.state.zubereitung}
            </div>
            <button className={deleteVisible}  onClick={ (e) => this.proofDeletion(e) } >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</button>
        </li>
      )
    }
  }
  export default Zubereitung;


// WEBPACK FOOTER //
// ./src/Zubereitung.js